module.exports = __webpack_public_path__ + "static/img/tst2-08-1.74f1797.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tst/tst2-08-1.gif
// module id = 9K5N
// module chunks = 1